import { EditGridColumnType } from "../../../../components/molGrid/libs/data/editGridColumnType";
import { GridColumnType } from "../../../../components/molGrid/libs/data/gridColumnType";
import Buttons from "../../../../components/ui/button/Buttons";


export const viewSchemaDataGridConfig = {
  isRowSelectable: true,
  allowEdit: false,
  hasChildGridTable: false,
  columns: [
    {
      name: "Id",
      fieldName: "xmlSchemaField",      
      allowShort: false,
      colStyle: {
        textAlign: "left",
        width: "10%",
      },
    },
    {
      name: "SchemaFieldName",
      fieldName: "displayName",
      colStyle: {
        textAlign: "left",
        width: "30%",
      },
      allowShort: false,
    },
    {
      name: "SchemaFieldType",
      fieldName: "schemaFieldType",
      colStyle: {
        textAlign: "left",
        width: "20%",
      },
      editColValidation: [
        { type: "required", message: "WorkingDays  is required." },
      ],
      allowShort: false,
    },
    {
      name: "Assigned Value",
      fieldName: "valFieldName",
      allowShort: false,
      colStyle: {
        textAlign: "left",
        width: "20%",
      },
    },
    {
      name: "Assign Value",
      fieldName: "isxmlElement",
      colType: GridColumnType.CUSTOM,
      renderCustomCol: (rowData) => {
        return (
          rowData?.schemaFieldType !== null && (
            <div className="custom-col-btn">
              <Buttons
                buttonText={
                  rowData?.valFieldName == null ? "Assign Value" : "ReAssign Value"
                }
                buttonTypeClassName="btn info-btn"
                onClick={() => rowData?.onCustomButtonClick(rowData)}
              />
            </div>
          )
        );
      },
      allowShort: false,
      colStyle: {
        width: "20%",
        textAlign: "center",
      },
    },
  ],
};
